export type Nullable<T> = { [K in keyof T]: T[K] | null };
export type NonEmptyArray<A> = A[] & { 0: A };
export const isNonEmptyArray = <A>(a: A[]): a is NonEmptyArray<A> =>
  a.length > 0;

export type ProductTrackingData = {
  itemType: "Product";
  produktLink: string;
  syan: string;
  farbId: string;
  position: string;
};

export type GiftcardTrackingData = {
  itemType: "Giftcard";
  produktLink: string;
  position: string;
};

export type RecoItemTrackingData = ProductTrackingData | GiftcardTrackingData;

export type CarouselTrackingData = {
  placement: string;
  strategy: string;
  currency: string;
  headline: string;
  pageName: string;
  recoItems: NonEmptyArray<RecoItemTrackingData>;
  abTestVariante?: string;
  abTestHeader?: string;
};

type UnrefinedItemType = { itemType: string | null };

type UnrefinedProductTrackingData = Omit<
  Partial<Nullable<ProductTrackingData>>,
  "itemType"
> &
  UnrefinedItemType;

type UnrefinedGiftcardTrackingData = Omit<
  Partial<Nullable<GiftcardTrackingData>>,
  "itemType"
> &
  UnrefinedItemType;

export const isProductTrackingData = (
  data: UnrefinedProductTrackingData,
): data is ProductTrackingData =>
  data.itemType !== null &&
  data.itemType !== undefined &&
  data.itemType === "Product" &&
  data.produktLink !== null &&
  data.produktLink !== undefined &&
  data.syan !== null &&
  data.syan !== undefined &&
  data.farbId !== null &&
  data.farbId !== undefined &&
  data.position !== null &&
  data.position !== undefined;

export const isGiftcardTrackingData = (
  data: UnrefinedGiftcardTrackingData,
): data is GiftcardTrackingData =>
  data.itemType !== null &&
  data.itemType !== undefined &&
  data.itemType === "Giftcard" &&
  data.produktLink !== null &&
  data.position !== null;
